import { useStrategy } from '../../hooks/useStrategy';
import { useCallback, useMemo } from 'react';
import QuickFiltersSimpleEnumValueDisplay from './QuickFiltersSimpleEnumValueDisplay';
import QuickFiltersReferenceEnumValueDisplay from './QuickFiltersReferenceEnumValueDisplay';
import { List } from 'immutable';
import { getInboundDbImportReferenceResolver } from 'customer-data-filters-ui/utils/getInboundDbImportReferenceResolver';
import { INBOUND_DB_IMPORT } from 'customer-data-objects/property/ExternalOptionTypes';
import { jsx as _jsx } from "react/jsx-runtime";
const QuickFiltersEnumValueDisplay = props => {
  const {
    filterFamily,
    condition,
    onValueDelete,
    use
  } = props;
  const {
    getValueResolver,
    getSpecialOptionsForReferenceType,
    getReferencedObjectType
  } = useStrategy();
  const resolver = useMemo(() => {
    const referenceResolver = getValueResolver(filterFamily, condition);
    if (typeof referenceResolver === 'function' && condition.field && condition.field.referencedObjectType === INBOUND_DB_IMPORT) {
      return getInboundDbImportReferenceResolver(
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'Function' is not assignable to p... Remove this comment to see the full error message
      referenceResolver, filterFamily);
    }
    return referenceResolver;
  }, [filterFamily, condition, getValueResolver]);
  const specialOptions = useMemo(() => getSpecialOptionsForReferenceType(getReferencedObjectType(filterFamily, condition), filterFamily), [condition, filterFamily, getSpecialOptionsForReferenceType, getReferencedObjectType]);
  const onValueDeleteLocal = useCallback(valueToDelete => {
    const newValue = condition.value.filter(item => item !== valueToDelete);
    if (newValue.count()) {
      onValueDelete(condition.set('value', newValue));
    } else {
      onValueDelete();
    }
  }, [onValueDelete, condition]);
  const parsedCondition = List.isList(condition.value) ? condition : condition.set('value', List([condition.value]));
  if (resolver) {
    return /*#__PURE__*/_jsx(QuickFiltersReferenceEnumValueDisplay, {
      condition: parsedCondition,
      resolver: resolver,
      specialOptions: specialOptions,
      onValueDelete: onValueDeleteLocal,
      use: use
    });
  }
  return /*#__PURE__*/_jsx(QuickFiltersSimpleEnumValueDisplay, {
    condition: parsedCondition,
    onValueDelete: onValueDeleteLocal,
    use: use
  });
};
export default QuickFiltersEnumValueDisplay;